/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 15);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isLoading = void 0;

module.exports = {
  isMobile: function isMobile() {
    return (/Mobile|Android|Silk\/|Kindle|BlackBerry|Opera Mini|Opera Mobi|webOS/i.test(navigator.userAgent)
    );
  },
  showLoading: function showLoading() {
    if (!isLoading) {
      isLoading = true;
      (0, _jquery2.default)('body').append('<div id="loading"><i class="fa fa-spinner"></i></div>');
    }
  },
  hideLoading: function hideLoading() {
    isLoading = false;
    (0, _jquery2.default)('#loading').remove();
  },
  numberWithCommas: function numberWithCommas(num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },


  /**
   * Throttle
   * use to limit function calls so we don't kill something.
   * https://remysharp.com/2010/07/21/throttling-function-calls
   */
  throttle: function throttle(func, delay) {
    var last, timer;

    return function () {
      var context = this;
      var now = new Date();
      var args = arguments;

      if (last && now < last + delay) {
        clearTimeout(timer);
        timer = setTimeout(function () {
          last = now;
          func.apply(context, args);
        }, delay);
      } else {
        last = now;
        func.apply(context, args);
      }
    };
  }
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Alert = {
  isActive: false,

  // Get message from flash message, then show it
  getMessage: function getMessage() {
    _jquery2.default.getJSON('/flash-message/view.json', function (data) {
      if (data.message) Alert.show({ level: 'warning', message: data.message });
    });
  },


  // accepts alert level & message, then shows it
  show: function show(options) {
    if (this.isActive) return;

    var markup = '<div class="alert alert-' + options.level + '" id="alert" style="display: none;">' + '<button type="button" class="close" data-dismiss="alert">&times;</button> ' + options.message + '</div>';

    this.isActive = true;
    (0, _jquery2.default)('body').append(markup);
    (0, _jquery2.default)('#alert').fadeIn();

    setTimeout(function () {
      Alert.destroy();
      Alert.isActive = false;
    }, 3000);
  },


  // hides alert, then destroys it
  destroy: function destroy() {
    (0, _jquery2.default)('#alert').fadeOut({
      done: function done() {
        (0, _jquery2.default)(this).remove();
      }
    });
  }
};

exports.default = Alert;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _alert = __webpack_require__(2);

var _alert2 = _interopRequireDefault(_alert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Watchlist = {
  // finds any elements with class, then binds them to the toggle function
  bind: function bind() {
    (0, _jquery2.default)('.watchlist-btn').off('click').on('click', this.toggle);
  },

  // Adds or removes car from watchlist
  toggle: function toggle(e) {
    e.preventDefault();

    var self = (0, _jquery2.default)(this),
        id = self.parent().data('id'),
        row = (0, _jquery2.default)('.result_' + id),
        addEl = (0, _jquery2.default)('.watchlist-buttons[data-id=' + id + ']').find('.add'),
        deleteEl = (0, _jquery2.default)('.watchlist-buttons[data-id=' + id + ']').find('.delete'),
        data = {
      'id': id
    },
        action = 'add';

    Watchlist.showLoading(self);

    if (self.hasClass("delete")) {
      action = 'remove';
      data['HTTP_X_HTTP_METHOD_OVERRIDE'] = 'DELETE';
    }

    _jquery2.default.ajax({
      'method': 'POST',
      'url': self.attr('href'),
      'dataType': 'json',
      'data': data
    }).done(function (response) {
      _alert2.default.show({
        level: 'success',
        message: response.message
      });

      switch (action) {
        case 'add':
          row.addClass('watchlisted');
          addEl.addClass("hidden");
          deleteEl.removeClass("hidden");
          break;
        case 'remove':
          row.removeClass('watchlisted');
          addEl.removeClass("hidden");
          deleteEl.addClass("hidden");
          break;
      }

      Watchlist.hideLoading(self);
    }).fail(function (response) {
      _alert2.default.show({
        level: 'danger',
        message: response.message
      });

      Watchlist.hideLoading(self);
    });
  },

  showLoading: function showLoading(el) {
    el.append('<span class="btn-loading"><i class="fa fa-spinner"></i></span>');
  },

  hideLoading: function hideLoading(el) {
    el.find('.btn-loading').remove();
  }
};

exports.default = Watchlist;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Car = {
  id: null,
  status: null,

  updateStatus: function updateStatus(options) {
    this.id = options.id;
    this.status = options.status;

    this.updateElements();
  },

  updateElements: function updateElements() {
    var result = (0, _jquery2.default)('.result_' + this.id);

    result.addClass(this.status);
  }
};

exports.default = Car;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _utils = __webpack_require__(1);

var _watchlist = __webpack_require__(3);

var _watchlist2 = _interopRequireDefault(_watchlist);

var _car = __webpack_require__(4);

var _car2 = _interopRequireDefault(_car);

var _bid = __webpack_require__(9);

var _bid2 = _interopRequireDefault(_bid);

var _start = __webpack_require__(7);

var _start2 = _interopRequireDefault(_start);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Modal = {
  element: null,
  content: null,
  id: null,
  request: null,

  init: function init() {
    this.element = (0, _jquery2.default)('#details');
    this.content = this.element.find('#details-content');

    window.onpopstate = this.onPopState;

    this.bind();
  },

  bind: function bind() {
    (0, _jquery2.default)('.show-details').off('click').on('click', this.showCarDetails);
  },

  show: function show() {
    this.element.modal('show');
  },

  hide: function hide() {
    this.element.modal('hide');
  },

  replaceContent: function replaceContent(content) {
    Modal.content.html(content);
    Modal.show();

    (0, _utils.hideLoading)();

    // Bind the different elements in the modal
    Modal.bindCarDetails();
    Modal.bindButtons();
    Modal.bindLightbox();
    Modal.bindExamples();
    _watchlist2.default.bind();
  },

  showCarDetails: function showCarDetails(e) {
    e.preventDefault();

    var self = (0, _jquery2.default)(this);
    var requestUrl = self.attr('href');

    Modal.id = requestUrl.split('=')[1];

    var baseUrl = window.location.href.split('#')[0];
    var newUrl = baseUrl + '#' + Modal.id;
    var title = (0, _jquery2.default)(document).attr('title');

    window.history.pushState({ id: Modal.id }, title, newUrl);
    _car2.default.updateStatus({ id: Modal.id, status: 'viewed' });

    if (Modal.request !== null) {
      Modal.request.abort();
    }

    (0, _utils.showLoading)();
    Modal.request = _jquery2.default.get(requestUrl, Modal.replaceContent);
  },

  bindCarDetails: function bindCarDetails() {
    var examples = (0, _jquery2.default)('#detail-price-examples');
    var average = (0, _jquery2.default)('#detail-price-average');

    examples.hide();

    if (Modal.request !== null) {
      Modal.request.abort();
    }

    Modal.request = _jquery2.default.post("/price-history/get.json", { id: Modal.id }, function (data) {
      examples.prepend(data.price.count).show();
      average.prepend((0, _utils.numberWithCommas)(data.price.average * 1000));
    });
  },

  bindButtons: function bindButtons() {
    (0, _jquery2.default)('#show-bid').off('click').on('click', _bid2.default.init);

    if (!_start2.default.pageList) return;

    var prev = (0, _jquery2.default)('.btn.previous');
    var next = (0, _jquery2.default)('.btn.next');
    var baseUrl = prev.attr('href');

    for (var i = 0; i < _start2.default.pageList.length; i++) {
      if ('#' + _start2.default.pageList[i] === window.location.hash) {
        if (i !== 0) {
          prev.css('display', 'inline-block');
          prev.attr('href', baseUrl + _start2.default.pageList[i - 1]);
          prev.on('click', this.showCarDetails);
        }
        if (i !== _start2.default.pageList.length - 1) {
          next.css('display', 'inline-block');
          next.attr('href', baseUrl + _start2.default.pageList[i + 1]);
          next.on('click', this.showCarDetails);
        }
      }
    }
  },

  bindLightbox: function bindLightbox() {
    (0, _jquery2.default)('.lightbox-image').magnificPopup({
      type: 'image',
      gallery: {
        enabled: true
      },
      callbacks: {
        buildControls: function buildControls() {
          this.contentContainer.append(this.arrowLeft.add(this.arrowRight));
        }, // re-appends controls inside the main container
        beforeOpen: function beforeOpen() {
          Modal.hide();
        }, // Hide modal while the lightbox is opened
        beforeClose: function beforeClose() {
          Modal.show();
        } // then put it back when the lightbox is closed
      }
    });
  },

  bindExamples: function bindExamples() {
    (0, _jquery2.default)('#detail-price-examples').on('click', function (e) {
      e.preventDefault();

      var detailsContent = Modal.content.html();

      _jquery2.default.get((0, _jquery2.default)(this).attr('href'), function (content) {
        Modal.content.html(content);

        (0, _jquery2.default)('#back-to-details').on('click', Modal.showCarDetails);
      });
    });
  },

  onPopState: function onPopState(e) {
    Main.showLoading();
    _jquery2.default.get('/cardetail/?id=' + e.state.id, Modal.replaceContent);
  }
};

exports.default = Modal;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _utils = __webpack_require__(1);

exports.default = {
  element: null,
  toggles: null,
  rowsParent: null,
  rows: null,
  activeOrder: 'desc',
  activeToggle: null,
  onStart: function onStart() {},
  onFinish: function onFinish() {},

  init: function init(options) {
    this.element = $('.sorter');
    this.toggles = this.element.find('[data-toggle="sorter"]');
    this.rowsParent = this.element.find('.sorter-rows');
    this.rows = this.rowsParent.find('.sorter-row');

    if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
      this.onStart = typeof options.onStart === 'function' ? options.onStart : function () {};
      this.onFinish = typeof options.onFinish === 'function' ? options.onFinish : function () {};
    }

    this.bind();
  },

  bind: function bind() {
    this.toggles.off('click').on('click', this.sort.bind(this));
  },

  sort: function sort(e) {
    e.preventDefault();

    (0, _utils.showLoading)();
    this.onStart();

    var toggle = $(e.currentTarget);
    var sortingValue = toggle.data('sort-by');

    if (this.activeToggle !== null && this.activeToggle === sortingValue) {

      if (this.activeOrder === 'desc') {
        this.activeOrder = 'asc';
      } else {
        this.activeOrder = 'desc';
      }
    } else {
      this.activeToggle = sortingValue;
      this.activeOrder = 'desc';
    }

    this.resetToggles();
    toggle.addClass('is-active');
    toggle.addClass('is-' + this.activeOrder);

    this.rows.sort(function (a, b) {
      var rowA, rowB;
      a = a.dataset[sortingValue];
      b = b.dataset[sortingValue];

      if (isNaN(a) || isNaN(b)) {
        rowA = a.toUpperCase();
        rowB = b.toUpperCase();
      } else {
        rowA = parseInt(a);
        rowB = parseInt(b);
      }

      if (rowA > rowB) {
        return 1;
      }
      if (rowA < rowB) {
        return -1;
      }

      return 0;
    });

    if (this.activeOrder === 'desc') {
      this.rows.reverse();
    }

    this.sortNodes();
  },

  sortNodes: function sortNodes() {
    var wrapper = this.rows.parent();

    this.rows.each(function (i) {
      wrapper.append($(this));
    });

    this.onFinish();
    (0, _utils.hideLoading)();
  },

  resetToggles: function resetToggles() {
    this.toggles.removeClass('is-active is-asc is-desc');
  }
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(1);

var _alert = __webpack_require__(2);

var _alert2 = _interopRequireDefault(_alert);

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _modal = __webpack_require__(5);

var _modal2 = _interopRequireDefault(_modal);

var _watchlist = __webpack_require__(3);

var _watchlist2 = _interopRequireDefault(_watchlist);

var _sorter = __webpack_require__(6);

var _sorter2 = _interopRequireDefault(_sorter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Start = {
  form: null,
  results: null,
  pageList: [],
  request: null,

  orderInput: null,
  sortInput: null,

  order: null,
  sortBy: null,

  init: function init() {
    this.form = (0, _jquery2.default)('#search-form');
    this.results = (0, _jquery2.default)('#search-results');

    this.orderInput = this.form.find('input[name=order]');
    this.sortInput = this.form.find('input[name=sort]');

    if (this.form.length !== 0) {
      this.bindFunctions();
      this.bindEvents();

      this.loadMakers();
      this.loadModels();

      this.checkHash();
    }
  },

  bindFunctions: function bindFunctions() {
    _jquery2.default.fn.ajaxWithMessage = this.ajaxMessage;
    _jquery2.default.fn.getAvailableMakers = this.getAvailableMakers;
    _jquery2.default.fn.getAvailableModels = this.getAvailableModels;
    _jquery2.default.fn.selectCurrentOrPreviousDates = this.selectCurrentOrPreviousDates;
  },

  bindEvents: function bindEvents() {
    (0, _jquery2.default)('#maker-select').getAvailableModels('change');
    (0, _jquery2.default)('#auction-select').getAvailableMakers('change');
    (0, _jquery2.default)('.date-select').getAvailableMakers('click');
    (0, _jquery2.default)('ul.auction-list input').selectCurrentOrPreviousDates('change');
    (0, _jquery2.default)("#save-search").ajaxWithMessage('/saved-searches/save', 'Your search has been saved');
    (0, _jquery2.default)("#email-results").ajaxWithMessage('/saved-searches/save?email=1', 'Your results will now be emailed to you once or twice daily');

    this.form.on('submit', this.submitSearch.bind(this));
  },

  // Load Makers
  loadMakers: function loadMakers() {
    var makers = Start.form.find('#maker-select');
    if (makers.length < 1) return;

    makers.html("<option value=''>Loading Makers</option>");
    _jquery2.default.getJSON('/start/makers.json', Start.form.serialize(), function (data) {
      var options = "<option value=''>Select Maker</option>";

      data.forEach(function (item, i, array) {
        options += "<option value='" + item.maker + "'>" + item.maker + "</option>\n";
      });

      makers.html(options);
    });
  },

  selectCurrentOrPreviousDates: function selectCurrentOrPreviousDates(event) {
    (0, _jquery2.default)(this).on(event, function (e) {
      if ((0, _jquery2.default)(this).closest('ul').hasClass('previous') && (0, _jquery2.default)('ul.current input:checked').length > 0) {
        (0, _jquery2.default)('ul.current input').each(function () {
          (0, _jquery2.default)(this).removeAttr('checked');
        });
      } else if ((0, _jquery2.default)(this).closest('ul').hasClass('current') && (0, _jquery2.default)('ul.previous input:checked').length > 0) {
        (0, _jquery2.default)('ul.previous input').each(function () {
          (0, _jquery2.default)(this).removeAttr('checked');
        });
      }
    });
  },

  loadModels: function loadModels() {
    var makers = Start.form.find('#maker-select');
    var models = Start.form.find('#model-select');

    if (makers.length < 1) return;

    (0, _utils.showLoading)();
    models.html("<option value=''>Loading Models</option>");
    if (makers.val() !== '') {
      _jquery2.default.getJSON('/start/models.json', Start.form.serialize(), function (data) {
        var options = "<option value=''>Select Model</option>";

        data.forEach(function (item, i, array) {
          options += "<option value='" + item.model + "'>" + item.model + "</option>\n";
        });

        models.html(options);
        (0, _utils.hideLoading)();
      });
    } else {
      models.html("<option value=''>Model - select maker first</option>");
      (0, _utils.hideLoading)();
    }
  },

  submitSearch: function submitSearch(e) {
    e.preventDefault();

    if (Start.request !== null) {
      Start.request.abort();
    }

    (0, _utils.showLoading)();
    Start.request = _jquery2.default.post(this.form.attr('action'), this.form.serialize(), function (data) {
      Start.results.html(data);
      (0, _utils.hideLoading)();

      Start.updatePageList();
      Start.markActiveOrder();
      _modal2.default.bind();
      _watchlist2.default.bind();
      _sorter2.default.init({ onFinish: Start.onSorterFinish });
    });
  },

  markActiveOrder: function markActiveOrder() {
    var toggles = Start.results.find('[data-toggle=sorter]');

    var activeToggle = toggles.filter(function () {
      return (0, _jquery2.default)(this).data('sort-by') === Start.sortBy;
    });

    activeToggle.addClass('is-active is-' + Start.order);
  },

  onSorterFinish: function onSorterFinish() {
    Start.order = this.activeOrder;
    Start.sortBy = this.activeToggle;

    Start.orderInput.val(Start.order);
    Start.sortInput.val(Start.sortBy);

    Start.updatePageList();
  },

  updatePageList: function updatePageList() {
    Start.pageList = [];

    Start.results.find('.result').each(function (index) {
      Start.pageList.push((0, _jquery2.default)(this).data('id'));
    });
  },

  checkHash: function checkHash() {
    if (window.location.hash != '') {
      _modal2.default.id = window.location.hash.replace('#', '');

      (0, _utils.showLoading)();
      _jquery2.default.get('/cardetail/?id=' + _modal2.default.id, _modal2.default.replaceContent);
    }
  },

  getAvailableMakers: function getAvailableMakers(event) {
    (0, _jquery2.default)(this).on(event, Start.loadMakers);
  },

  getAvailableModels: function getAvailableModels(event) {
    (0, _jquery2.default)(this).on(event, Start.loadModels);
  },

  ajaxMessage: function ajaxMessage(url, message) {
    (0, _jquery2.default)(this).on('click', function () {
      (0, _utils.showLoading)();
      _jquery2.default.post(url, Start.form.serialize(), function (data) {
        (0, _utils.hideLoading)();
        _alert2.default.show({ level: 'success', message: data + message });
      });
    });
  }
};

exports.default = Start;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _menu = __webpack_require__(10);

var _menu2 = _interopRequireDefault(_menu);

var _modal = __webpack_require__(5);

var _modal2 = _interopRequireDefault(_modal);

var _sorter = __webpack_require__(6);

var _sorter2 = _interopRequireDefault(_sorter);

var _other_date = __webpack_require__(11);

var _other_date2 = _interopRequireDefault(_other_date);

var _watchlist = __webpack_require__(3);

var _watchlist2 = _interopRequireDefault(_watchlist);

var _saved_searches = __webpack_require__(14);

var _saved_searches2 = _interopRequireDefault(_saved_searches);

var _remove_watch = __webpack_require__(13);

var _remove_watch2 = _interopRequireDefault(_remove_watch);

var _start = __webpack_require__(7);

var _start2 = _interopRequireDefault(_start);

var _price_search = __webpack_require__(12);

var _price_search2 = _interopRequireDefault(_price_search);

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
function bindFunctions() {
  _jquery2.default.fn.reverse = [].reverse;
}

function init() {
  bindFunctions();

  _menu2.default.init();
  _modal2.default.init();
  _sorter2.default.init();
  _other_date2.default.bind();
  _watchlist2.default.bind();
  _saved_searches2.default.bind();
  _remove_watch2.default.bind();

  _start2.default.init();
  _price_search2.default.init();
}

exports.default = init;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _alert = __webpack_require__(2);

var _alert2 = _interopRequireDefault(_alert);

var _car = __webpack_require__(4);

var _car2 = _interopRequireDefault(_car);

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Bid = {
  details: null,
  element: null,
  form: null,
  id: null,
  request: null,

  init: function init(e) {
    e.preventDefault();
    var url = (0, _jquery2.default)(this).attr('href');

    Bid.details = (0, _jquery2.default)('#car');
    Bid.element = (0, _jquery2.default)('#bid');
    Bid.id = url.split('=')[1];

    (0, _utils.showLoading)();
    Bid.element.load(url, function () {
      (0, _utils.hideLoading)();

      Bid.form = (0, _jquery2.default)('#bid-form');
      Bid.cancel = (0, _jquery2.default)('#cancel-bid');

      Bid.bindEvents();
      Bid.showForm();
    });
  },

  showForm: function showForm() {
    this.details.hide();
    this.element.show();
  },

  hideForm: function hideForm(e) {
    if (typeof e !== 'undefined') e.preventDefault();

    Bid.details.show();
    Bid.element.html('');
  },

  bindEvents: function bindEvents() {
    Bid.form.on('submit', Bid.submitForm);
    Bid.cancel.on('click', Bid.hideForm);
  },

  submitForm: function submitForm(e) {
    e.preventDefault();

    if (Bid.request !== null) {
      Bid.request.abort();
    }

    Bid.request = _jquery2.default.post(Bid.form.attr('action'), Bid.form.serialize(), function (response) {
      var alertLevel = 'danger';

      if (response.code === 200) {
        Bid.hideForm();
        _car2.default.updateStatus({ id: Bid.id, status: 'has-bid' });
        alertLevel = 'success';

        (0, _jquery2.default)('#show-bid').off('click').removeClass('orange-btn').addClass('blue-btn').html('Go To Bids').attr('href', '/bids');
      }

      if (typeof response.message !== 'undefined') {
        _alert2.default.show({ level: alertLevel, message: response.message });
      }
    });
  }
};

exports.default = Bid;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Menu = {
  fixedHeader: null,
  dropdowns: null,

  init: function init() {
    if ((0, _utils.isMobile)()) {
      this.dropdowns = (0, _jquery2.default)('.dropdown > a');

      this.dropdowns.off('click').on('click', this.toggleDropdown);
    } else {
      this.fixedHeader = (0, _jquery2.default)('#fixed-header');
      this.dropdowns = (0, _jquery2.default)('.dropdown');

      (0, _jquery2.default)(window).on('scroll', (0, _utils.throttle)(this.toggleFixed, 100));

      this.dropdowns.off('click mouseenter mouseleave').on('mouseenter', this.showDropdown).on('mouseleave', this.hideDropdown);
    }
  },

  toggleFixed: function toggleFixed() {
    var posY = (0, _jquery2.default)(window).scrollTop();
    var isVisible = Menu.fixedHeader.is(':visible');

    if (posY > 106) {
      if (!isVisible) {
        Menu.fixedHeader.stop().fadeIn(300);
      }
    } else {
      Menu.fixedHeader.stop().hide();
    }
  },

  showDropdown: function showDropdown(e) {
    var self = (0, _jquery2.default)(this);
    self.addClass('open');
    self.attr('aria-expanded', 'true');
  },

  hideDropdown: function hideDropdown(e) {
    var self = (0, _jquery2.default)(this);
    self.removeClass('open');
    self.attr('aria-expanded', 'false');
  },

  toggleDropdown: function toggleDropdown(e) {
    e.preventDefault();

    var self = (0, _jquery2.default)(this);
    var parent = self.parent();
    parent.toggleClass('open');

    if (parent.attr('aria-expanded') == 'false') {
      parent.attr('aria-expanded', 'true');
    } else {
      parent.attr('aria-expanded', 'false');
    }
  }
};

exports.default = Menu;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _alert = __webpack_require__(2);

var _alert2 = _interopRequireDefault(_alert);

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  form: null,

  bind: function bind() {
    this.form = (0, _jquery2.default)('#other-date');

    this.form.on('submit', this.search);
  },

  search: function search(e) {
    e.preventDefault();

    var datePattern = /(\d{4})\-(\d{1,2})\-(\d{1,2})/;
    var value = (0, _jquery2.default)('#date-field').val();

    if (value.match(datePattern)) {
      window.location.href = '/bids/' + value;
    } else {
      _alert2.default.show({ 'level': 'danger', 'message': 'Incorrect date format, please verify the date and try again.' });
    }
  }
};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PriceSearch = {
  form: null,
  results: null,
  request: null,

  init: function init() {
    this.form = (0, _jquery2.default)('#price-form');
    this.results = (0, _jquery2.default)('#search-results');
    this.makers = this.form.find('#maker-select');
    this.models = this.form.find('#model-select');

    if (this.form.length !== 0) {
      this.loadMakers();
      this.loadModels();

      this.bindEvents();
    }
  },

  bindEvents: function bindEvents() {
    this.makers.on('change', this.loadModels);
    this.form.on('submit', this.submitSearch);
  },

  submitSearch: function submitSearch(e) {
    e.preventDefault();

    if (PriceSearch.request !== null) {
      PriceSearch.request.abort();
    }

    (0, _utils.showLoading)();
    PriceSearch.request = _jquery2.default.post('/price-history/results', PriceSearch.form.serialize(), function (data) {
      PriceSearch.results.html(data);
      (0, _utils.hideLoading)();
      (0, _jquery2.default)('.after-search').show();

      Sorter.init();
    });
  },

  loadMakers: function loadMakers() {
    if (PriceSearch.makers.length < 1) return;

    PriceSearch.makers.html("<option value=''>Loading Makers</option>");
    _jquery2.default.getJSON('/start/makers.json', PriceSearch.form.serialize(), function (data) {
      var options = "<option value=''>Select Maker</option>";

      data.forEach(function (item, i, array) {
        options += "<option value='" + item.maker + "'>" + item.maker + "</option>\n";
      });

      PriceSearch.makers.html(options);
    });
  },

  loadModels: function loadModels() {
    if (PriceSearch.makers.length < 1) return;

    (0, _utils.showLoading)();
    PriceSearch.models.html("<option value=''>Loading Models</option>");
    if (PriceSearch.makers.val() !== '') {
      _jquery2.default.getJSON('/start/models.json', PriceSearch.form.serialize(), function (data) {
        var options = "<option value=''>Select Model</option>";

        data.forEach(function (item, i, array) {
          options += "<option value='" + item.model + "'>" + item.model + "</option>\n";
        });

        PriceSearch.models.html(options);
        (0, _utils.hideLoading)();
      });
    } else {
      PriceSearch.models.html("<option value=''>Model - select maker first</option>");
      (0, _utils.hideLoading)();
    }
  }
};

exports.default = PriceSearch;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _alert = __webpack_require__(2);

var _alert2 = _interopRequireDefault(_alert);

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RemoveWatch = {
  btns: null,
  request: null,

  bind: function bind() {
    this.btns = (0, _jquery2.default)('.delete-watch');
    this.count = (0, _jquery2.default)('#results-count');

    this.btns.off('click').on('click', this.removeWatch);
  },

  removeWatch: function removeWatch(e) {
    e.preventDefault();

    var self = (0, _jquery2.default)(this);
    var id = self.data('id');
    var row = self.closest('tr');
    var data = {
      'id': id,
      'HTTP_X_HTTP_METHOD_OVERRIDE': 'DELETE'
    };

    if (RemoveWatch.request !== null) {
      RemoveWatch.request.abort();
    }

    RemoveWatch.request = _jquery2.default.ajax({
      'method': 'POST',
      'url': self.attr('href'),
      'dataType': 'json',
      'data': data
    }).done(function (response) {
      _alert2.default.show({ level: 'success', message: response.message });
      row.remove();
      RemoveWatch.reduceCount();
    }).fail(function (response) {
      _alert2.default.show({ level: 'danger', message: response.message });
    });
  },

  reduceCount: function reduceCount() {
    var oldCount = parseInt(this.count.html());

    this.count.html(oldCount - 1);
  }
};

exports.default = RemoveWatch;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SavedSearches = {
  bind: function bind() {
    (0, _jquery2.default)('.search-action').off('click').on('click', this.confirmAction);
  },

  confirmAction: function confirmAction(e) {
    e.preventDefault();

    var proceed = confirm('Are you sure you would like to ' + (0, _jquery2.default)(this).html().toLowerCase() + '?');

    if (proceed) {
      (0, _utils.showLoading)();
      _jquery2.default.get((0, _jquery2.default)(this).attr('href'), SavedSearches.replaceContent);
      (0, _utils.hideLoading)();
    }
  },

  replaceContent: function replaceContent(content) {
    (0, _jquery2.default)('#main_column').html(content);
    SavedSearches.bind();
  }
};

exports.default = SavedSearches;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _init = __webpack_require__(8);

var _init2 = _interopRequireDefault(_init);

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(function () {
  (0, _init2.default)();
});

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app/webroot/javascript/application.js